import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { WidgetsService } from '../../widgets.service';
import { SearchItem } from '../../../../entities';
import { AppService } from '../../../../app.service';
import { FleetCondition } from '../../widgets.model';
import { Subscription } from 'rxjs/Subscription';
import { NotificationsService } from 'angular2-notifications';
import { WidgetsEnlargedComponentComponent } from '../widgets-enlarged-component/widgets-enlarged-component.component';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '../../../../../app/translate';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cost-of-repairs-monthly-widget',
  templateUrl: './cost-of-repairs-monthly-widget.component.html',
  styleUrls: ['./cost-of-repairs-monthly-widget.component.scss']
})
export class CostOfRepairsMonthlyWidgetComponent implements OnInit, OnDestroy {
  @Input() chartid: string;

  @Input() passedDataSource: any;
  @Input() isInPopup: boolean = false;
  translateSubscription: Subscription;
  userLanguage = 'english';
  width: number = 280;
  height: number = 180;
  type: string = 'column2d';
  dataFormat: string = 'json';
  dataSource: any;
  fleetCondition: FleetCondition;
  subscriptions: Subscription[] = [];
  //widgetTriggerSubscription: Subscription;
  emptySearchSelectionQuery: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: "Evaluation X" }];
  loading: boolean = true;
  noData: boolean = false;

  enableTab:boolean=false
  constructor(private _widgets: WidgetsService,private _translate: TranslateService,private ref: ChangeDetectorRef,
    private _app: AppService,
    private _notification: NotificationsService, 
    private _dialog: MatDialog) {
    this.dataSource = {
      "chart": {
        "numDivLines": "5",
        "showValues": "0",
        "rotateLabels": "1",
        "slantLabels": "0",
        "plotSpacePercent": "10",
        "paletteColors": "#2290F9,#26F1D4",
        "columnHoverAlpha": "80",
        "canvasBaseDepth": "5",
        "showBorder": "0",
        "showYAxisLine": "0",
        "canvasBorderAlpha": "5",
        "showLimits": "0",
        "theme": "zune",
        "numberPrefix": "$",
        "bgColor": "#ffffff",
        "yAxisValuesPadding": "5"
      },
      "data": [
        {
          "label": this.Translate("Jan"),
          "value": "2700"
        },
        {
          "label": this.Translate("Feb"),
          "value": "200"
        },
        {
          "label": this.Translate("Mar"),
          "value": "680"
        },
        {
          "label": this.Translate("Apr"),
          "value": "1025"
        },
        {
          "label": this.Translate("Apr"),
          "value": "1025"
        },
        {
          "label": this.Translate("Jul"),
          "value": "1200"
        },
        {
          "label": this.Translate("Aug"),
          "value": "2400"
        },
        {
          "label": this.Translate("Sep"),
          "value": "2800"
        },
        {
          "label": this.Translate("Oct"),
          "value": "1584"
        },
        {
          "label": this.Translate("Nov"),
          "value": "359"
        },
        {
          "label":this.Translate( "Dec"),
          "value": "1870"
        }
      ]
    };
  }

  ngOnInit() {
    this.enableTab=this._app.getEnableSearch()
    if(this.passedDataSource != null ){
      console.log("received   ", this.passedDataSource);
      this.subscriptions.push(         
        this.passedDataSource.subscribe(r=>this.loadDataToGraph(r))
        //  this.passedDataSource.forEach(c=>this.pushResult(c))
      );
      
      this.loading = false;
      if(this.isInPopup){
        this.width = 460;
        this.height = 360;
      }
    }
    else{
      this.loadWidget(this._app.getLastSelectionSearchItems());
    }

    // this.loadWidget(this._app.getLastSelectionSearchItems());
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      if ( s!=undefined   && !s.closed)
        s.unsubscribe();
    });
    //this.widgetTriggerSubscription.unsubscribe();
    this.translateSubscription.unsubscribe();
  }
   updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  dataSourceToPass : any;

  openWithANewPopup() {
   
    let dialogRef = this._dialog.open(WidgetsEnlargedComponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        chartId: this.chartid,
        dataSource: this.dataSourceToPass,
        chartTitle: "Total Cost of Repairs",     
      }
    });

    dialogRef.afterClosed().subscribe(r => {

    });

  }

  loadWidget(searchSelection: SearchItem[]) {
    this.loading = true;
    this.subscriptions.push(this._widgets.getTotalCostOfRepairs(searchSelection).subscribe(r => {
      this.dataSourceToPass = Observable.of(r);
     this.loadDataToGraph(r);
    }, error => {
      this._notification.error('Error', 'Failed to load Total Cost of Repairs. '); console.log(error);
    }));
  }



  
  loadDataToGraph(r){
    this.dataSource.data = [];
    let totalCost = 0;
    r.forEach(i => {
      if (i != null) {
        this.dataSource.data.push({ "label":this.Translate(i.Month), "value": i.Cost });
        totalCost += i.Cost;
      }
    });
    if (totalCost == 0)
      this.noData = true;
    else
      this.noData = false;
    this.loading = false;
  } 


}
